import "@debitroom-software/vuetify-crud/style.css";

import vuetifyAlert from "@debitroom-software/vuetify-alert";
import VuetifyCrud from "@debitroom-software/vuetify-crud";
import { useSnackbar } from "@debitroom-software/vuetify-snackbar-queue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import type { App } from "vue";

import { post } from "@/shared/api/apiInstance";
import useScopedTranslations from "@/shared/plugins/i18n/composables/useScopedTranslations";
import initSentry from "@/shared/plugins/sentry";

import router from "../router/index";
import i18n from "./i18n";
import pinia from "./pinia";
import vuetify from "./vuetify";

export function registerPlugins(app: App) {
  initSentry(app, router);
  app
    .use(vuetify)
    .use(router)
    .use(pinia)
    .use(i18n)
    .use(vuetifyAlert, {
      closeBtnText: (i18n.global as any).t("global.actions.close"),
      continueBtnText: (i18n.global as any).t("global.actions.continue")
    })
    .component("FontAwesomeIcon", FontAwesomeIcon);

  app.use(VuetifyCrud, {
    useScopedTranslations,
    useSnackbar,
    inlineDetailWidth: 50,
    apiInstance: { post }
  });
}
